import { render, staticRenderFns } from "./ApproveHOPopUp.vue?vue&type=template&id=1f8bc467&scoped=true&lang=pug"
import script from "./ApproveHOPopUp.vue?vue&type=script&lang=ts"
export * from "./ApproveHOPopUp.vue?vue&type=script&lang=ts"
import style0 from "./ApproveHOPopUp.vue?vue&type=style&index=0&id=1f8bc467&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8bc467",
  null
  
)

/* custom blocks */
import block0 from "./ApproveHOPopUp.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FPopups%2FApproveHOPopUp.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports